import React, { createContext, useContext, useEffect, useState } from 'react';
import apiClient from './apiClient';

interface NotificationsContextValue {
  unreadCount: number | null;
  refreshUnread: () => Promise<void>;
}

const NotificationsContext = createContext<NotificationsContextValue | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState<number | null>(null);

  const refreshUnread = async () => {
    try {
      const res = await apiClient.get('/notifications', {
        params: { unread: 1, pageSize: 1 },
      });
      const anyData: any = res.data;
      const total = anyData.data?.pagination?.total;
      if (typeof total === 'number') {
        setUnreadCount(total);
      } else {
        setUnreadCount(0);
      }
    } catch {
      setUnreadCount(null);
    }
  };

  useEffect(() => {
    refreshUnread();
  }, []);

  return (
    <NotificationsContext.Provider value={{ unreadCount, refreshUnread }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = (): NotificationsContextValue => {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotifications must be used within NotificationsProvider');
  }
  return ctx;
};
